import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiTabs = {
  styleOverrides: {
    root: ({ theme }) => ({
      minHeight: 40,
      ...(theme.palette.mode === 'dark' && {
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
      }),
    }),
    indicator: ({ theme }) => ({
      height: 3,
      borderRadius: '3px 3px 0 0',
      backgroundColor: 'var(--mui-palette-primary-main)',
      ...(theme.palette.mode === 'dark' && {
        boxShadow: '0 0 10px rgba(99, 91, 255, 0.35)',
      }),
    }),
  },
} satisfies Components<Theme>['MuiTabs'];

export const MuiSelect = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...(theme.palette.mode === 'dark' && {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(255, 255, 255, 0.14)',
        },
      }),
    }),
  },
} satisfies Components<Theme>['MuiSelect'];
